import { render, staticRenderFns } from "./credit-overview.vue?vue&type=template&id=0f227be8"
import script from "./credit-overview.vue?vue&type=script&lang=ts"
export * from "./credit-overview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports